export default "__VITE_ASSET__C94J7jGA__"